import React from 'react';
import { VideoItemSummary } from '../../../services/quizContentAdminService';
import { QUIZ_REVIEW_NAV_COPY as COPY } from './navCopy';

/**
 * A video item. NO overlay, in any mode.
 *
 * The canonical English title and the existing `captions <status>` badge are
 * untouched, and no marker ever appears on one — Spanish captions are a separate
 * feature and out of scope here. In Both mode the two cells are identical by
 * design; that is the honest rendering of "this item has no translation concept",
 * not an oversight.
 */
const VideoCard: React.FC<{ v: VideoItemSummary; index: number; fullHeight?: boolean }> = ({
  v,
  index,
  fullHeight,
}) => {
  const mins = v.duration_seconds != null ? Math.floor(v.duration_seconds / 60) : null;
  const secs = v.duration_seconds != null ? v.duration_seconds % 60 : null;
  return (
    <div
      className={`border-l-4 border-video pl-3 py-1 bg-video-light/40 rounded-r${
        fullHeight ? ' h-full' : ''
      }`}
    >
      <div className="font-semibold text-ink mb-1">
        🎬 V{index}. {v.title || COPY.untitledVideo}{' '}
        <span className="text-xs font-normal text-video">
          · no XP
          {mins != null ? ` · ${mins}:${String(secs).padStart(2, '0')}` : ''}
          {v.published ? ' · published' : ' · draft'}
          {` · captions ${v.captions_status}`}
        </span>
      </div>
    </div>
  );
};

export default VideoCard;
